// AUTO-GENERATED by scripts/generate-version.js — do not edit by hand.
// Regenerated on every build from git metadata.

export const APP_VERSION       = "0.0.1";
export const BUILD_NUMBER      = "67";
export const BUILD_SHA         = "a078936";
export const BUILD_DATE        = "2026-05-02T08:13:46.098Z";
export const VERSION_LABEL     = "v0.0.1 · build 67 · a078936";
export const STORAGE_ENCRYPTED = true;
